<template>
  <div id="footer">
    <!--overlay-->
    <transition name="fade">
    <div id="overlay" v-if="this.display_card===true">
      <div id="overlayCard" class="whiteBG">
        <div class="close" @click="closeCard"></div>

        <div id="cardInner" v-if="!this.bug_report_valid">
          <!--report a bug-->
          <div v-if="this.content==='report_bug'">
            <div class="title">
              <h2>Report a bug</h2>
              <p>Help us make better product.</p>
            </div>
            <img src="../../assets/img/bug.svg" style="transform:rotate(-45deg);-webkit-transform:rotate(-45deg);">
              <form class="section" method="post">
                <label for="fullName" class="note" id="fullNameLabel">Your Name*</label>
                <input type="text" id="fullName" name="fullName" v-model="bug_report.username" placeholder="Your full name" required @blur="validateRequired('fullName','fullNameLabel')" @keyup="validateRequired('fullName','fullNameLabel')">
                <p class="note errormsg" v-if="name_error_msg.length>1">{{name_error_msg}}</p>

                <label for="email" class="note" id="emailLabel">Email*</label>
                <input type="email" id="email" name="email" v-model="bug_report.email" placeholder="In case we need to connect with you" required @blur="validateEmail" @keyup="validateEmail">
                <p class="note errormsg" v-if="email_error_msg.length>1">{{email_error_msg}}</p>

                <label for="url" class="note" id="urlLabel">URL*</label>
                <input type="url" id="url" name="url" v-model="bug_report.url" placeholder="The URL of the problem page" required @blur="validateURL" @keyup="validateURL">
                <p class="note errormsg">{{url_error_msg}}</p>

                <label for="textarea" class="note" id="textareaLabel">Description*</label>
                <textarea id="textarea" rows="6" v-model="bug_report.desc" required placeholder="Please describe:
  - The issue
  - Steps we can take to reproduce the issue" @blur="validateTextarea" @keyup="validateTextarea"></textarea>
                <p class="note errormsg" v-if="textarea_error_msg.length>1">{{textarea_error_msg}}</p>

                <div style="width:100%;text-align: center;"><div class="btnSecondary" @click="processBugReport">Submit</div></div>
              </form>
          </div>

          <!--make a suggestion-->
          <div v-if="this.content==='make_suggestion'">
            <div class="title">
              <h2>Make a suggestion</h2>
              <p>You speak. We listen.</p>
            </div>
            <img src="../../assets/img/suggestion.svg">
             <form class="section">
              <label for="fullName" class="note" id="fullNameLabel">Your Name*</label>
              <input type="text" id="fullName" name="fullName" v-model="suggestion.username" placeholder="Your full name" required @blur="validateRequired('fullName','fullNameLabel')" @keyup="validateRequired('fullName','fullNameLabel')">
              <p class="note errormsg" v-if="name_error_msg.length>1">{{name_error_msg}}</p>

              <label for="email" class="note" id="emailLabel">Email*</label>
              <input type="email" id="email" name="email" v-model="suggestion.email" placeholder="In case we need to connect with you" required @blur="validateEmail" @keyup="validateEmail">
              <p class="note errormsg" v-if="email_error_msg.length>1">{{email_error_msg}}</p>

              <label for="url" class="note" id="urlLabel">URL</label>
              <input type="url" id="url" name="url" v-model="suggestion.url" placeholder="The URL of related pages">

              <label for="textarea" class="note" id="textareaLabel">Suggestion*</label>
              <textarea id="textarea" rows="6" v-model="suggestion.desc" required placeholder="How can we make improvements?" @blur="validateTextarea" @keyup="validateTextarea"></textarea>
              <p class="note errormsg" v-if="textarea_error_msg.length>1">{{textarea_error_msg}}</p>

              <div style="width:100%;text-align: center;"><div class="btnSecondary" @click="processSuggestion">Submit</div></div>
            </form>
          </div>

          <!--add a course-->
          <div v-if="this.content==='add_course'">
            <div class="title">
              <h2>Add a course</h2>
              <p>Your contribution matters.</p>
            </div>
            <img src="../../assets/img/course.svg">
            <form class="section">
              <label for="title" class="note" id="titleLabel">Course Title*</label>
              <input type="text" id="title" name="url" v-model="new_course.course_title" placeholder="The official name of the course" required @blur="validateRequired('title','titleLabel')" @keyup="validateRequired('title','titleLabel')">
              <p class="note errormsg" v-if="coursetitle_error_msg.length>1">{{coursetitle_error_msg}}</p>

              <label for="url" class="note" id="urlLabel">Course URL*</label>
              <input type="url" id="url" name="url" v-model="new_course.course_url" placeholder="So that we can verify course information" required @blur="validateURL" @keyup="validateURL">
              <p class="note errormsg">{{url_error_msg}}</p>

              <label for="fullName" class="note" id="fullNameLabel">Your Name*</label>
              <input type="text" id="fullName" name="fullName" v-model="new_course.user_name" placeholder="It will appear in our contributor list in the future" required @blur="validateRequired('fullName','fullNameLabel')" @keyup="validateRequired('fullName','fullNameLabel')">
              <p class="note errormsg" v-if="name_error_msg.length>1">{{name_error_msg}}</p>

              <label for="email" class="note" id="emailLabel">Email*</label>
              <input type="email" id="email" name="email" v-model="new_course.user_email" placeholder="We will notify you if the course is added" required @blur="validateEmail" @keyup="validateEmail">
              <p class="note errormsg" v-if="email_error_msg.length>1">{{email_error_msg}}</p>

              <label for="textarea" class="note">Additional Notes</label>
              <textarea id="textarea" rows="6" v-model="new_course.notes" placeholder="Anything comment you would like to make about this course? "></textarea>

              <div id="courseDefinition">
                <h3>What qualifies as a course?</h3>
                <p>A course is a series of lessons about one specific subject or skill that meets the following criteria:<br><br>
                  <span>Continuity</span><br>Topics are developed in a logical manner - in that way a collection of discrete topics does not make a course.<br><br>
                  <span>Minimum Efforts</span><br>The learning spans through at least 4 hours.<br><br>
                  <span>Originality</span><br>Material is created, organized or tutored by the original creator.
                </p>
              </div>
              <div style="width:100%;text-align: center;"><div class="btnSecondary" @click="processNewCourse">Submit</div></div>
            </form>
          </div>
        </div>

        <div id="confirm" v-if="this.bug_report_valid">
          <div v-if="this.content==='report_bug'">
            <img src="../../assets/img/bug_in_jar.svg">
            <div class="confirmationText">
             <h2>Nice Catch!</h2>
             <p>We will report this issue to our engineers to get it fixed.<br>Thanks again for helping us making Warm Machine better!</p>
             <div style="width:100%;text-align: center;"><div class="btnSecondary" @click="closeCard">Got it</div></div>
            </div>
          </div>

          <div v-if="this.content==='make_suggestion'">
            <img src="../../assets/img/suggestion.svg">
            <div class="confirmationText">
             <h2>We heard you.</h2>
             <p>Your opinion means a lot to us.<br>We will carefully review your suggestion and get back to you soon.</p>
             <div style="width:100%;text-align: center;"><div class="btnSecondary" @click="closeCard">Got it</div></div>
            </div>
          </div>

          <div v-if="this.content==='add_course'">
            <img src="../../assets/img/course.svg">
            <div class="confirmationText">
             <h2>You’re awesome!</h2>
             <p>We will review your submission carefully. The review usually takes 1-3 business days and we will notify you the result.<br><br>Thanks again for your contribution!</p>
             <div style="width:100%;text-align: center;"><div class="btnSecondary" @click="closeCard">Got it</div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </transition>
    <!--the actual footer-->
    <div class="footer" v-bind:class="{blur: this.display_card}">
      <p id="actions">
        <span id="bug" class="a" @click="displayCard('report_bug')"><i class="fal fa-bug"></i>Report a bug</span>
        &nbsp;&nbsp;&#183;&nbsp;&nbsp;
        <span id="suggestion" class="a" @click="displayCard('make_suggestion')"><i class="fal fa-lightbulb"></i>Suggestions</span>
        &nbsp;&nbsp;&#183;&nbsp;&nbsp;
        <span id="addCourse" class="a" @click="displayCard('add_course')"><i class="fal fa-backpack"></i>Add a course</span>
        &nbsp;&nbsp;&#183;&nbsp;&nbsp;
        <a id="contact" href ="mailto: contact@warmmachine.org"><i class="fal fa-envelope-open"></i>Contact us</a>
      </p>
      <p id="copyright">&#169; 2021 WarmMachine</p>
    </div>
  </div>
</template>

<script>
  import {createBugReport, createNewCourse, createSuggestion} from "../../api/api";

export default {
  name: 'Footer',
  data () {
    return {
      display_card: false,
      content: '',
      name_error_msg: '',
      email_error_msg: '',
      url_error_msg: '',
      textarea_error_msg: '',
      coursetitle_error_msg: '',
      bug_report_valid: false,

      //record user's input
      bug_report:{
        username: '',
        email: '',
        url: '',
        desc: ''
      },
      suggestion: {
        username: '',
        email: '',
        url: '',
        desc: ''
      },
      new_course: {
        course_title: '',
        course_url: '',
        user_name: '',
        user_email: '',
        notes: ''
      }
    }
  },
  methods: {
    displayCard: function (section) {
      this.name_error_msg = ''
      this.email_error_msg = ''
      this.url_error_msg = ''
      this.coursetitle_error_msg = ''
      this.textarea_error_msg = ''
      this.bug_report_valid = false
      this.display_card = true
      this.content = section
      return (this.content)
    },
    closeCard: function () {
      this.display_card = false
    },
    validateRequired: function (id, label) {
      let input = document.getElementById(id)
      let inputLabel = document.getElementById(label)
      if (input.validity.valueMissing) {
        if (inputLabel.innerHTML === 'Your Name*') {
          this.name_error_msg = 'Your name is required.'
        } else {
          this.coursetitle_error_msg = 'The title of the course is required.'
        }
        input.classList.add('invalidInput')
        inputLabel.classList.add('invalidLabel')
        return false
      } else {
        this.name_error_msg = ''
        this.coursetitle_error_msg = ''
        input.classList.remove('invalidInput')
        inputLabel.classList.remove('invalidLabel')
        return true
      }
    },
    validateEmail: function () {
      let email = document.getElementById('email')
      let emailLabel = document.getElementById('emailLabel')
      if (email.validity.valueMissing) {
        this.email_error_msg = 'Your email is required.'
        email.classList.add('invalidInput')
        emailLabel.classList.add('invalidLabel')
        return false
      } else {
        if (email.validity.typeMismatch) {
          this.email_error_msg = "Hmm...that doesn't look like an email to me."
          email.classList.add('invalidInput')
          emailLabel.classList.add('invalidLabel')
          return false
        } else {
          this.email_error_msg = ''
          email.classList.remove('invalidInput')
          emailLabel.classList.remove('invalidLabel')
          return true
        }
      }
    },
    validateURL: function () {
      let url = document.getElementById('url')
      let urlLabel = document.getElementById('urlLabel')
      if (url.validity.valueMissing) {
        this.url_error_msg = 'The url of the problem page is required.'
        url.classList.add('invalidInput')
        urlLabel.classList.add('invalidLabel')
        return false
      } else {
        if (url.validity.typeMismatch) {
          this.url_error_msg = "Hmm...that doesn't look like an url to me."
          url.classList.add('invalidInput')
          urlLabel.classList.add('invalidLabel')
          return false
        } else {
          this.url_error_msg = ''
          url.classList.remove('invalidInput')
          urlLabel.classList.remove('invalidLabel')
          return true
        }
      }
    },
    validateTextarea: function () {
      let textarea = document.getElementById('textarea')
      let textareaLabel = document.getElementById('textareaLabel')
      if (textarea.validity.valueMissing) {
        if (textareaLabel.innerHTML === 'Description*') {
          this.textarea_error_msg = 'Your description of the problem is required.'
          textarea.classList.add('invalidTextarea')
          textareaLabel.classList.add('invalidLabel')
          return false
        } else {
          this.textarea_error_msg = "We'd like to learn the detail of your suggestion."
          textarea.classList.add('invalidTextarea')
          textareaLabel.classList.add('invalidLabel')
          return false
        }
      } else {
        this.textarea_error_msg = ''
        textarea.classList.remove('invalidTextarea')
        textareaLabel.classList.remove('invalidLabel')
        return true
      }
    },
    validateBugReportForm: function () {
      this.validateRequired('fullName', 'fullNameLabel')
      this.validateEmail()
      this.validateURL()
      this.validateTextarea()
      if (this.validateRequired('fullName', 'fullNameLabel') && this.validateEmail() && this.validateURL() && this.validateTextarea()) {
        this.bug_report_valid = true
      } else {
        this.bug_report_valid = false
      }
    },
    validateSuggestionForm: function () {
      this.validateRequired('fullName', 'fullNameLabel')
      this.validateEmail()
      this.validateTextarea()
      if (this.validateRequired('fullName', 'fullNameLabel') && this.validateEmail() && this.validateTextarea()) {
        this.bug_report_valid = true
      } else {
        this.bug_report_valid = false
      }
    },
    validateAddCourseForm: function () {
      this.validateRequired('title', 'titleLabel')
      this.validateURL()
      this.validateRequired('fullName', 'fullNameLabel')
      this.validateEmail()
      if (this.validateRequired('title', 'titleLabel') && this.validateEmail() && this.validateURL() && this.validateRequired('fullName', 'fullNameLabel')) {
        this.bug_report_valid = true
      } else {
        this.bug_report_valid = false
      }
    },
    sendBugReport() {
      createBugReport({
        user_name: this.bug_report.username,
        user_email: this.bug_report.email,
        url: this.bug_report.url,
        description: this.bug_report.desc
      })
    },
    processBugReport() {
      this.validateBugReportForm();
      if (this.bug_report_valid){
        this.sendBugReport()
      }
    },
    sendSuggestion(){
      createSuggestion({
        user_name: this.suggestion.username,
        user_email: this.suggestion.email,
        url: this.suggestion.url,
        description: this.suggestion.desc
      })
    },
    processSuggestion() {
      this.validateSuggestionForm();
      if (this.bug_report_valid){
        this.sendSuggestion()
      }
    },
    sendNewCourse() {
      createNewCourse({
        course_title: this.new_course.course_title,
        course_url: this.new_course.course_url,
        user_name: this.new_course.user_name,
        user_email: this.new_course.user_email,
        notes: this.new_course.notes
      })
    },
    processNewCourse() {
      this.validateAddCourseForm();
      if (this.bug_report_valid){
        this.sendNewCourse()
      }
    }
  }
}
</script>

<style>
  @import '../../assets/style/general.css';
</style>



// WEBPACK FOOTER //
// src/view/General/Footer.vue